/**
 * Raw events of the Grid V2 A/B test (tracking spec: Grid V2 Tracking Spec,
 * https://hopper-jira.atlassian.net/wiki/spaces/RBC/pages/9256435762).
 */

export enum GridV2RawEventName {
  GridV2OptedOut = "GridV2OptedOut",
}

export type GridV2Screen =
  | "flight_list"
  | "intro_modal"
  | "comparison_modal"
  | "opt_out_modal"
  | "pricing_explainer";

/**
 * Emitted when the opt-out endpoint responds, success or failure. The
 * transformer adds the search the user opted out from.
 */
export interface GridV2OptedOutRawEvent {
  name: GridV2RawEventName.GridV2OptedOut;
  properties: {
    success: boolean;
    failure_reason?: string;
    screen: GridV2Screen;
    /** Properties the server sent on the opt-out response, merged as-is. */
    serverProperties?: Record<string, unknown>;
  };
}

export type GridV2RawEvent = GridV2OptedOutRawEvent;
